"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var react_dom_1 = require("react-dom");
var utils_1 = require("../utils");
function cloneWithClass(child, className) {
    if (!child) {
        return null;
    }
    return React.cloneElement(child, {
        className: classnames_1.default(child.props.className, className)
    });
}
var Portal = /** @class */ (function (_super) {
    tslib_1.__extends(Portal, _super);
    function Portal(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.setEnter = function () {
            if (_this.state.isEnter) {
                return;
            }
            clearTimeout(_this.leaveTimeout);
            var children = _this.props.children;
            _this.$child = children;
            _this.setState({ isEnter: true, isEnterActive: false, isLeave: false, isLeaveActive: false, showing: true }, function () {
                _this.setEnterActive();
                _this.enterTimeout = setTimeout(function () {
                    _this.setState({
                        isEnter: false,
                        isEnterActive: false,
                        isLeave: false,
                        isLeaveActive: false
                    });
                }, _this.props.transitionDuration);
            });
        };
        _this.setEnterActive = function () {
            if (_this.state.isEnterActive) {
                return;
            }
            setTimeout(function () {
                _this.setState({ isEnterActive: true });
            });
        };
        _this.setLeave = function () {
            if (_this.state.isLeave) {
                return;
            }
            clearTimeout(_this.enterTimeout);
            _this.setState({ isEnter: false, isEnterActive: false, isLeave: true, isLeaveActive: false }, function () {
                _this.setLeaveActive();
                _this.leaveTimeout = setTimeout(function () {
                    _this.setState({
                        isEnter: false,
                        isEnterActive: false,
                        isLeave: false,
                        isLeaveActive: false,
                        showing: false
                    });
                    _this.$child = null;
                }, _this.props.transitionDuration);
            });
        };
        _this.setLeaveActive = function () {
            if (_this.state.isLeaveActive) {
                return;
            }
            utils_1.raf(function () {
                _this.setState({ isLeaveActive: true });
            });
        };
        _this.enterTimeout = null;
        _this.leaveTimeout = null;
        _this.$child = null;
        _this.state = { isEnter: false, isEnterActive: false, isLeave: false, isLeaveActive: false, showing: false };
        return _this;
    }
    Object.defineProperty(Portal.prototype, "useTransition", {
        get: function () {
            var _a = this.props, transitionClasses = _a.transitionClasses, transitionDuration = _a.transitionDuration;
            return !!transitionClasses && !!transitionDuration;
        },
        enumerable: true,
        configurable: true
    });
    Portal.prototype.componentDidMount = function () {
        this.handleTransition({});
    };
    Portal.prototype.componentDidUpdate = function (prevProps) {
        this.handleTransition(prevProps);
    };
    Portal.prototype.handleTransition = function (prevProps) {
        if (!this.useTransition) {
            return;
        }
        var children = this.props.children;
        if (children && !prevProps.children) {
            this.setEnter();
        }
        else if (!children && prevProps.children && this.$child) {
            this.setLeave();
        }
        else if (this.$child && this.state.showing && children && this.$child !== children) {
            this.$child = children;
        }
    };
    Portal.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, container = _b.container, transitionClasses = _b.transitionClasses;
        var _c = this.state, showing = _c.showing, isEnter = _c.isEnter, isEnterActive = _c.isEnterActive, isLeave = _c.isLeave, isLeaveActive = _c.isLeaveActive;
        var $container = document.querySelector(container);
        if (this.useTransition) {
            if (showing) {
                var classes = classnames_1.default((_a = {},
                    _a[transitionClasses.enter] = isEnter,
                    _a[transitionClasses.enterActive] = isEnterActive,
                    _a[transitionClasses.leave] = isLeave,
                    _a[transitionClasses.leaveActive] = isLeaveActive,
                    _a));
                return react_dom_1.createPortal(cloneWithClass(this.$child, classes), $container);
            }
            return null;
        }
        return react_dom_1.createPortal(children, $container);
    };
    Portal.defaultProps = {
        container: "body"
    };
    return Portal;
}(React.Component));
exports.default = Portal;
